import { IRefIds } from 'constants/refs';
import { getCacheKey } from 'helpers/cache';
import { useCacheData } from 'hooks/useCacheData';
import React, { useEffect, useMemo, useState } from 'react';
import { SelectLayout } from './SelectLayout';
import TranslationProjectsModel, { ITranslationProjectSelect } from '../../models/TranslationProjectsModel';

type IProps = {
  onChange?: (translationProject: ITranslationProjectSelect) => void;
  className?: string;
  courseId: number;
  selectedId?: number | null;
};

const TranslationProjectSelect: React.FC<IProps> = (props) => {
  const [currentTranslationProjectId, setCurrentTranslationProjectId] = useState<number | null>(
    props.selectedId ?? null,
  );
  const cacheKey = getCacheKey(IRefIds.translationProject, props.courseId);
  const dataModel = useMemo(() => new TranslationProjectsModel(props.courseId), [props.courseId]);
  const cacheSelectData = useCacheData(cacheKey, dataModel.get.bind(dataModel));

  useEffect(() => {
    setCurrentTranslationProjectId(props.selectedId ?? null);
  }, [props.selectedId]);

  const handleChange = (value: ITranslationProjectSelect) => {
    const selectedTranslationProjectId = value.id;
    setCurrentTranslationProjectId(selectedTranslationProjectId);
    props.onChange && props.onChange(value);
  };

  return (
    <SelectLayout
      className={props.className}
      data={cacheSelectData}
      onChange={handleChange}
      label="Translation Project"
      optionLabelKey="name"
      currentValue={currentTranslationProjectId}
    />
  );
};

export default TranslationProjectSelect;
